import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AppRoutes from './routes';

import HeaderTop from './components/HeaderTop';
import HeaderBar from './components/HeaderBar';
import Loader from './components/Loader';
import PageWrapper from './components/PageWrapper';
import Footer from './components/Footer';

function App() {
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();

    // Liste des routes où header/footer sont masqués
    const hideHeaderFooterPages = ['/not-found'];

    // Vérification si l'utilisateur est sur une page qui cache header/footer
    const shouldHideHeaderFooter = hideHeaderFooterPages.some((path) =>
        location.pathname.startsWith(path)
    );

    useEffect(() => {
        const handleRouteChange = () => {
            setIsLoading(true);
            setTimeout(() => setIsLoading(false), 100);
        };

        handleRouteChange();

        // Optionnel : nettoyage ou abonnement supplémentaire ici
    }, [location]);

    return (
        <>
            {!shouldHideHeaderFooter && (
                <>
                    <HeaderTop />
                    <HeaderBar />
                </>
            )}
            {isLoading && <Loader />}
            <PageWrapper locationKey={location.key}>
                <AppRoutes />
            </PageWrapper>
            {!shouldHideHeaderFooter && <Footer />}
        </>
    );
}

export default App;
